import { createContext } from 'react';

const Api = createContext(null);

export default Api;
